<template>
  <ux-modal
    class="add-order"
    width="540px"
    v-model="showModal"
    :title="$t('HT.orderDetail.created')"
    :close="hideModal"
  >
    <div class="add-order-cont">
      <ux-form
        class="my-vertical-form"
        ref="form"
        :rules="rules"
        :data="formData"
        hide-btn
        width="380px"
        hideRequired
      >
        <!-- 选择分类 -->
        <ux-form-item :label="$t('HT.workList.type')" key="type" prop="type">
          <ux-select v-model="formData.type" :options="typeOpions"></ux-select>
        </ux-form-item>

        <!-- 工单描述 -->
        <ux-form-item :label="$t('HT.workList.info')" key="desc" prop="desc">
          <ux-input
            v-model="formData.desc"
            type="textarea"
            show-word-limit
            :placeholder="$t('HT.workList.info.placeholder')"
            :maxlength="1000"
            :autosize="{ minRows: 5, maxRows: 5 }"
          ></ux-input>
        </ux-form-item>

        <!-- 上传图片 -->
        <ux-form-item :label="$t('HT.workList.uploadImg')" key="imgList" prop="imgList">
          <ux-upload
            type="image"
            :text="$t('HT.workList.uploadImg')"
            accept="image/jpeg, image/png, image/gif"
            :acceptTip="$t('HT.workList.uploadImg.tip')"
            :list="formData.imgList"
            :limit="3"
            :size="1024 * 3"
          ></ux-upload>
        </ux-form-item>
      </ux-form>
    </div>
    <template slot="footer">
      <div class="add-order-footer">
        <ux-button plain @click="hideModal">{{ $t('HT.cancel') }}</ux-button>
        <ux-button type="primary" @click="confirm">{{ $t('HT.submit') }}</ux-button>
      </div>
    </template>
  </ux-modal>
</template>

<script>
import timeButton from '@/views/template/timeButton';
import OSS from 'ali-oss';

export default {
  name: 'AddOrder',
  components: {
    timeButton
  },
  props: {
    // 用户名
    username: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showModal: false,
      userData: {}, // 用户信息
      rules: this.$rul.addOrder(),
      formData: {
        type: '', // 类型
        desc: '', // 描述
        imgList: [] // 图片
      },
      typeOpions: [],
      uploadImageList: []
    };
  },

  created() {
    this.userData = this.$store.state.login.userData;
    this.getTitle();
    this.$nextTick(() => {
      this.showModal = true;
    });
  },

  methods: {
    // 获取标题类型
    getTitle() {
      this.$api.workOrder.getTitle().then((res) => {
        if (res.code == 10000) {
          const data = res.data || [];
          if (data.length === 0) return;
          this.typeOpions = data.map((item) => {
            return {
              label: item.title_key ? this.$t(item.title_key) : item.title,
              value: item.id
            };
          });
          this.formData.type = this.typeOpions[0].value;
        }
      });
    },
    /**
     * 关闭弹窗
     */
    hideModal() {
      this.showModal = false;
      let timer = setTimeout(() => {
        clearTimeout(timer);
        timer = null;
        this.$emit('close');
      }, 500);
    },

    /**
     * 确认回调
     */
    confirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          // this.createWorkOrder();
          this.uploadImage();
        }
      });
    },
    // 上传图片
    uploadImage() {
      const { imgList } = this.formData;
      this.uploadImageList = [];
      if (imgList.length > 0) {
        this.$api.faceRecognition.getOssToken({ bucket: 'BUCKET_WORK_ORDER' }).then((res) => {
          if (res.code == 10000) {
            const promises = [];
            imgList.forEach((item) => {
              const p = this.ossClient(res.data, item);
              promises.push(p);
            });
            Promise.all(promises).then((res) => {
              this.uploadImageList = res;
              this.createWorkOrder();
            });
          }
        });
      } else {
        this.createWorkOrder();
      }
    },
    // 上传至阿里云
    ossClient(params, file) {
      return new Promise((resolve) => {
        const _this = this;
        // 实例化OSS Client。
        const client = new OSS({
          // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
          contentType: '',
          region: params.region,
          // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
          accessKeyId: params.access_key_id,
          accessKeySecret: params.access_key_secret,
          // 从STS服务获取的安全令牌（SecurityToken）。
          stsToken: params.sts_token,
          refreshSTSToken: async () => {
            // 向您搭建的STS服务获取临时访问凭证。
            const info = await _this.getOssToken();
            // console.log('info', info);
            return {
              accessKeyId: info.access_key_id,
              accessKeySecret: info.access_key_secret,
              stsToken: info.sts_token
            };
          },
          // 刷新临时访问凭证的时间间隔，单位为毫秒。
          refreshSTSTokenInterval: 3600,
          // 填写Bucket名称。
          bucket: params.bucket
        });
        // file表示浏览器中需要上传的文件，支持HTML5 file和Blob类型。
        let fileName = file.name;
        fileName = fileName.substring(0, file.name.lastIndexOf('.'));
        fileName = `order_${fileName}_${new Date().getTime()}.jpg`;
        // fileName = fileName + '_' + new Date().getTime() + '.jpg';
        // console.log(file.name, fileName, file.raw);
        client
          .put(fileName, file.raw, {
            headers: {
              'Content-Type': 'image/jpg'
            }
          })
          .then(function (r1) {
            console.log('put success: %j', r1);
            return client.signatureUrl(fileName, { expires: 60 * 5 });
          })
          .then(function (r2) {
            console.log('get success: %j', r2);
            resolve(fileName);
          })
          .catch(function (err) {
            console.error('error: %j', err);
          });
      });
    },
    getOssToken() {
      const _this = this;
      return new Promise(function (resolve) {
        _this.$api.faceRecognition.getOssToken({ bucket: 'BUCKET_WORK_ORDER' }).then((res) => {
          if (res.code == 10000) {
            resolve(res.data);
          }
        });
      });
    },
    // 创建工单
    createWorkOrder() {
      this.$uxLoading.show();

      const { desc, type } = this.formData;
      const { id, username } = this.userData;
      let params = new FormData();

      params.append('describe', desc); // 问题描述
      params.append('sendRole', 0); // 发送角色(0：用户，1：客服）
      params.append('titleId', type); // 工单标题
      params.append('userId', id); // 用户id
      params.append('userName', username); // 用户名字
      params.append('sendId', id); // 用户名字

      this.uploadImageList.forEach((item, idx) => {
        params.append(`image${idx + 1}`, item);
      });
      this.$api.workOrder
        .createWorkOrder(params)
        .then((res) => {
          if (res.code == 10000) {
            this.$uxMessage.success(this.$t('HT.addPlugin.createdSuccess'));
            this.hideModal();
            this.$emit('add-over');
          }
        })
        .catch((err) => {
          const { sub_msg } = err.response.data || {};
          this.$uxMessage.error(sub_msg || this.$t('HT.addPlugin.createdError'));
        })
        .finally(() => {
          this.$uxLoading.hide();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.add-order-cont {
  position: relative;
  display: flex;
  justify-content: center;
  padding-top: 40px;
}

.add-order-footer {
  text-align: right;
  padding-top: 32px;

  .ux-button {
    margin-left: 8px;
  }
}
</style>
